// @ngInject
const config = ($stateProvider) => {
  $stateProvider.state('configuration.vdcTemplates', {
    url: '/vdctemplates',
    templateUrl: 'main/configuration/vdcTemplates/vdcTemplates.tpl.html',
    data: { pageTitle: 'VDC Templates' },
  });
};

angular.module('configuration.vdcTemplates', []).config(config);
